import Raven from 'raven-js'
import setupApp from './setup-app'
import config from "../config"

if (config.SHOULD_INSTALL_RAVEN) {
  Raven
    .config(config.SENTRY_DSN)
    .install()
}

setupApp()
